import { RecordStatus } from "./../data-types/common/index";
import { IPagedResultDto, UpdateManyDto } from "./../types";
import { Record, Identifier } from "react-admin";
import { FilterInputDto } from "./../service-proxies/api";
import Axios, { AxiosResponse } from "axios";
import { ICrudApiProxy } from "../types";

const MOCK_API_URL = "http://localhost:3001";

export const MockDataApiFactory = (resourceName: string): ICrudApiProxy => {
  const axios = Axios.create({
    baseURL: MOCK_API_URL,
  });
  return {
    getFilteredList: async <RecordType extends Record = Record>(
      filterInputDto?: FilterInputDto,
      options?: any
    ) => {
      console.log(
        "Sending get-filtered-list request with filter parameters: ",
        filterInputDto
      );
      const response: AxiosResponse<RecordType[]> = await axios.request({
        url: `/${resourceName}`,
        method: "GET",
      });
      const retVal: AxiosResponse<IPagedResultDto<RecordType>> = {
        ...response,
        data: {
          totalCount: response.data.length,
          items: response.data,
        },
      };
      return retVal;
    },

    getOneById: async <RecordType extends Record = Record>(
      id: string,
      options?: any
    ) => {
      const response: AxiosResponse<RecordType> = await axios.request({
        url: `/${resourceName}/${id}`,
        method: "GET",
      });
      return response;
    },

    createOne: async <RecordType extends Record = Record>(
      dto?: any,
      options?: any
    ) => {
      const response: AxiosResponse<RecordType> = await axios.request({
        url: `/${resourceName}`,
        method: "POST",
        data: dto,
      });
      return response;
    },

    updateOne: async <RecordType extends Record = Record>(
      id: string,
      dto?: any,
      options?: any
    ) => {
      const response: AxiosResponse<RecordType> = await axios.request({
        url: `/${resourceName}/${id}`,
        method: "PUT",
        data: dto,
      });
      return response;
    },

    updateMany: async (dto?: UpdateManyDto, options?: any) => {
      const response: AxiosResponse<Record[]> = await axios.request({
        url: `/${resourceName}/updateMany`,
        method: "POST",
        data: dto,
      });
      return {
        ...response,
        data: response.data.map((x) => x.id as string),
      };
    },

    changeStatus: async (
      id: Identifier,
      status: RecordStatus,
      options?: any
    ) => {
      const response: AxiosResponse<Record[]> = await axios.request({
        url: `/${resourceName}/updateMany`,
        method: "POST",
        data: { ids: [id], data: { status: status } },
      });
      return {
        ...response,
        data: undefined,
      };
    },
  };
};
